
import "../../../Foundation/stylable/colors.st.css.js";

import { classesRuntime, statesRuntime } from "./../../../stylable-esm-runtime.js";



var _namespace_ = "wds_1_182_0_IconAffix";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_182_0_IconAffix__root"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {"wds-color-text-disabled":"--wds-color-text-disabled","wds-space-50":"--wds-space-50","wds-input-icon-affix-fill":"--wds-input-icon-affix-fill"}; 




